import React, { useState, useRef, useEffect } from "react";
import { InformationCircleIcon } from "@heroicons/react/24/outline";

const StripeFinancialConnectionInfo = () => {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const onDocClick = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("click", onDocClick);
    return () => document.removeEventListener("click", onDocClick);
  }, []);

  const toggle = (e) => {
    e.stopPropagation();
    setOpen((v) => !v);
  };

  return (
    <div className="stripe-financial-connection-info mt-3" ref={containerRef}>
      <div
        className={`stripe-financial-connection-info__chip ${open ? "open" : ""}`}
        tabIndex="0"
        role="button"
        aria-expanded={open}
        onClick={toggle}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            toggle(e);
          }
        }}
      >
        <InformationCircleIcon width={18} height={18} />
        <span>How we use your data with Stripe</span>
        <div
          className="stripe-financial-connection-info__popover"
          role="tooltip"
        >
          Placeholder legal copy: we only use the Stripe data needed to pay out
          creators.
        </div>
      </div>
    </div>
  );
};

export default StripeFinancialConnectionInfo;
